import { Observable, combineLatest, map } from 'rxjs';

import { ratingsApi } from 'api/modules';
import { MarketRatingInfo, NetworkSlug, ProductSlug, VersionSlug } from 'domain/types';

import { getMarketBadDebtRatingInfo } from './getMarketBadDebtRatingInfo';
import { getMarketManipulationComplexityRatingInfo } from './getMarketManipulationComplexityRatingInfo';

export function getMarketRatingInfo({
  productSlug,
  versionSlug,
  network,
  marketId,
}: {
  productSlug: ProductSlug;
  versionSlug: VersionSlug;
  network: NetworkSlug;
  marketId: string;
}): Observable<MarketRatingInfo> {
  return combineLatest([
    getMarketBadDebtRatingInfo({ productSlug, versionSlug, network, marketId }),
    getMarketManipulationComplexityRatingInfo({
      productSlug,
      versionSlug,
      network,
      marketId,
    }),
    ratingsApi.getWorstMarketRating$({ productSlug, versionSlug, network, marketId }),
  ]).pipe(
    map(([badDebtInfo, manipulationComplexityInfo, marketRating]) => ({
      badDebtInfo,
      manipulationComplexityInfo,
      marketRating: marketRating.map(({ rating }) => rating),
    })),
  );
}
